import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVauxhallComponent } from './simple-icons-vauxhall.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVauxhallComponent ],
    exports:      [ SimpleIconsVauxhallComponent ],
    bootstrap:    []
})
export class SimpleIconsVauxhallModule {}
